"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var Entity_1 = require("../../Core/Entity");
var StoreEntity_1 = __importDefault(require("../../Core/StoreEntity"));
var ChatConversation_consts_1 = require("../ChatConversation.consts");
var Routes = {
    UpdateLastRead: '/chat_conversations/{:id}/update_last_read'
};
var ChatConversation = /** @class */ (function (_super) {
    __extends(ChatConversation, _super);
    function ChatConversation(session) {
        var _this = _super.call(this, {
            session: session,
            entityName: 'chat_conversations',
            routes: [Entity_1.BaseRoutes.Create, Entity_1.BaseRoutes.Get, Entity_1.BaseRoutes.GetAll]
        }) || this;
        _this._itemIdsByPage = {};
        _this.realTime.on('conversation removed', function (chatConversationRemoved) {
            return _this.store.removeFromStore(chatConversationRemoved.conversation_id);
        });
        _this.realTime.on('conversation created', function (chatConversationCreated) {
            return _this.store.addToStore(
            //@ts-expect-error - Type mismatch in event structure
            chatConversationCreated.conversation || chatConversationCreated);
        });
        _this.realTime.on('conversation update', function (chatConversationUpdate) {
            return _this.store.updateInStore(
            //@ts-expect-error - Type mismatch in event structure
            chatConversationUpdate.conversation || chatConversationUpdate);
        });
        return _this;
    }
    ChatConversation.prototype.updateLastRead = function (id, serverTimeStamp) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .post(Routes.UpdateLastRead)
                            .withRouteParams({ id: id })
                            .withPayload({ server_timestamp: serverTimeStamp })
                            .setException('Failed to update conversation last read')
                            .invoke()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ChatConversation.prototype.getConversations = function (page, options) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                options = (0, lodash_1.extend)(options, { page: page });
                response = this.isPageFetched(options.page)
                    ? this._getPage(options.page)
                    : this._fetchConversations(options);
                return [2 /*return*/, response];
            });
        });
    };
    ChatConversation.prototype.getConversation = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrFetch(id, ChatConversation_consts_1.singleExtractor, ChatConversation_consts_1.singleExtractor)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ChatConversation.prototype.createConversation = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.create(request, ChatConversation_consts_1.singleExtractor)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.conversation];
                }
            });
        });
    };
    ChatConversation.prototype._getPage = function (pageNumber) {
        var page = this._itemIdsByPage[pageNumber];
        if (page) {
            var conversations = page.itemsIds.map(this.store.getItem);
            return {
                conversations: conversations,
                has_next_page: page.hasNextPage,
                success: true,
                rc: 0
            };
        }
    };
    ChatConversation.prototype._addPage = function (items, page, hasNextPage) {
        var _this = this;
        items.forEach(function (item) { return _this.store.addToStore(item); });
        this._itemIdsByPage[page] = {
            hasNextPage: hasNextPage,
            itemsIds: items.map(function (item) { return item.id; })
        };
    };
    ChatConversation.prototype.isPageFetched = function (page) {
        return Boolean(this._itemIdsByPage[page]);
    };
    ChatConversation.prototype._fetchConversations = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.getAll(options)];
                    case 1:
                        response = _a.sent();
                        this._addPage(response.conversations, options.page, response.has_next_page);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return ChatConversation;
}(StoreEntity_1.default));
exports.default = ChatConversation;
//# sourceMappingURL=ChatConversation.js.map